"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocaleReceiver = void 0;
var tslib_1 = require("tslib");
/*
 * @Description:
 * @Autor: fenghuayu
 * @Date: 2022-01-05 16:05:41
 * @LastEditors: fenghuayu
 * @LastEditTime: 2022-02-20 20:31:36
 */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
var React = tslib_1.__importStar(require("react"));
var context_1 = tslib_1.__importDefault(require("./context"));
var zh_CN_1 = tslib_1.__importDefault(require("./zh_CN"));
var LocaleReceiver = /** @class */ (function (_super) {
    tslib_1.__extends(LocaleReceiver, _super);
    function LocaleReceiver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocaleReceiver.prototype.getLocale = function () {
        var _a = this.props, componentName = _a.componentName, defaultLocale = _a.defaultLocale;
        var locale = defaultLocale || zh_CN_1.default[componentName || 'global'];
        var antLocale = this.context;
        var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
        return tslib_1.__assign(tslib_1.__assign({}, (typeof locale === 'function' ? locale() : locale)), (localeFromContext || {}));
    };
    LocaleReceiver.prototype.getLocaleCode = function () {
        var antLocale = this.context;
        var localeCode = antLocale && antLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (antLocale && antLocale.exist && !localeCode) {
            return zh_CN_1.default.locale;
        }
        return localeCode;
    };
    LocaleReceiver.prototype.render = function () {
        return this.props.children(this.getLocale(), this.getLocaleCode(), this.context);
    };
    LocaleReceiver.defaultProps = {
        componentName: 'global',
    };
    LocaleReceiver.contextType = context_1.default;
    return LocaleReceiver;
}(React.Component));
exports.default = LocaleReceiver;
function useLocaleReceiver(componentName, defaultLocale) {
    var antLocale = React.useContext(context_1.default);
    var componentLocale = React.useMemo(function () {
        var locale = defaultLocale || zh_CN_1.default[componentName || 'global'];
        var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
        return tslib_1.__assign(tslib_1.__assign({}, (typeof locale === 'function' ? locale() : locale)), (localeFromContext || {}));
    }, [componentName, defaultLocale, antLocale]);
    return [componentLocale];
}
exports.useLocaleReceiver = useLocaleReceiver;
//# sourceMappingURL=LocaleReceiver.js.map